var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ending-view"},[_c('transition',{on:{"enter":_vm.onShowOverlay}},[_c('overlay',{attrs:{"tile":_vm.overlayData},on:{"close":_vm.hideOverlay}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }